import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

import { trackPageview } from "@/client/utils/gtm";

export const usePageTracking = () => {
  const location = useLocation();
  const lastTracked = useRef<string>("");

  useEffect(() => {
    const path = location.pathname + location.search;
    // Dedupe: React Strict Mode (and some navigations) can run the effect twice.
    // Only push one page_view per distinct URL.
    if (path === lastTracked.current) return;
    lastTracked.current = path;
    trackPageview(path);
  }, [location.pathname, location.search]);
};
